import { render } from "./SharedProfileDataCreate.vue?vue&type=template&id=30cff8a4&scoped=true"
import script from "./SharedProfileDataCreate.vue?vue&type=script&lang=js"
export * from "./SharedProfileDataCreate.vue?vue&type=script&lang=js"

import "./SharedProfileDataCreate.vue?vue&type=style&index=0&id=30cff8a4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30cff8a4"]])

export default __exports__